import { Flex, Box, Badge, Text, ModalFooter, Button } from '@chakra-ui/react';

import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { useRef, useCallback, useState, useEffect } from 'react';
import { ModalComponent } from '..';
import Input from '../../../Global/Input';
import TextArea from '../../../Global/TextArea';
import Select from '../../../Global/SelectRelease';
import getValidationErrors from '../../../../utils/getValidationErrors';
import { apllyToast } from '../../../Global/Toast2.0';
import { api } from '../../../../services/api';

interface DestinyInfos {
  destiny: string;
  description: string;
  leader: string;
}

interface IpropsModal {
  formateDateStartAppointments: string;
  formateDateEndAppointments: string;
  loading: boolean;
  isOpen: boolean;
  onClose: () => void;
  handleSubmitScheduleVehicle: (data: DestinyInfos) => void;
}

interface IAuthorizerOption {
  label: string;
  value: string;
}

// Nome da lista de distribuição (agenda) que define os autorizadores da frota.
// Os mesmos contatos dessa lista recebem o e-mail de aviso do agendamento.
const AUTHORIZERS_SCHEDULE = 'miles-schedule-group';

export function ModalScheduleConfirmationAppointment({
  handleSubmitScheduleVehicle,
  formateDateStartAppointments,
  formateDateEndAppointments,
  isOpen,
  onClose,
  loading,
}: IpropsModal) {
  const formRef = useRef<FormHandles>(null);
  const [reasonItem, setReason] = useState('');
  const [options, setOptions] = useState<IAuthorizerOption[]>([
    { label: 'Selecione...', value: '' },
  ]);

  // Carrega os autorizadores da lista de distribuição (configurável, sem
  // precisar alterar o código quando a equipe de logística mudar).
  useEffect(() => {
    if (!isOpen) return;
    api
      .get(`/schedules/show?name_schedule=${AUTHORIZERS_SCHEDULE}`)
      .then(response => {
        const list = Array.isArray(response.data) ? response.data : [];
        setOptions([
          { label: 'Selecione...', value: '' },
          ...list.map((item: { name: string }) => ({
            label: item.name,
            value: item.name,
          })),
        ]);
      })
      .catch(() => {
        setOptions([{ label: 'Selecione...', value: '' }]);
      });
  }, [isOpen]);

  const handleSubmit = useCallback(
    async (data: DestinyInfos) => {
      try {
        formRef.current?.setErrors({});

        if (!reasonItem) {
          apllyToast('warning', 'Selecione um autorizador');
          return;
        }

        const schema = Yup.object().shape({
          destiny: Yup.string().required('Destino é obrigatório'),
          description: Yup.string().required('Descrição é obrigatória'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const { description, destiny } = data;
        const formateData = {
          description,
          destiny,
          leader: reasonItem,
        };
        handleSubmitScheduleVehicle(formateData);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          formRef.current?.setErrors(getValidationErrors(err));
          return;
        }
        apllyToast(
          'error',
          'Problemas ao agendar veículo, revise as informações.',
        );
      }
    },
    [handleSubmitScheduleVehicle, reasonItem],
  );
  const handleReason = useCallback(e => {
    setReason(e);
  }, []);
  return (
    <ModalComponent
      title="Confirmar solicitação de agendamento"
      onClose={onClose}
      isOpen={isOpen}
    >
      <Form ref={formRef} onSubmit={handleSubmit}>
        <Flex direction="column" p="25">
          <Box>
            <Badge colorScheme="green">Saindo</Badge>
            <Text>{formateDateStartAppointments} </Text>
          </Box>

          <Box mt="5">
            <Badge colorScheme="red">Retornando</Badge>
            <Text>{formateDateEndAppointments} </Text>
          </Box>

          <Flex
            // border="1px"
            // borderColor="green"
            bg="gray.800"
            direction="column"
            p="15px"
            mt="5"
            borderRadius="6"
          >
            <Text fontSize="15" fontWeight="600">
              Destino
            </Text>
            <Input name="destiny" type="text" placeholder="Campo Grande" />

            <Box>
              <Text fontSize="15" fontWeight="600" mt="2">
                Descrição
              </Text>

              <TextArea
                name="description"
                placeholder="Levar veiculo para revisão manutençao preventiva de 10.000 km"
              />
            </Box>

            <Box>
              <Text fontSize="15" fontWeight="600" mt="2">
                Selecione um autorizador
              </Text>

              <Select
                name="authorizing"
                onChange={e => {
                  handleReason(e.target.value);
                }}
                label=""
                options={options}
              />
            </Box>
          </Flex>
        </Flex>
        <ModalFooter>
          <Button
            onClick={onClose}
            isLoading={loading}
            colorScheme="gray"
            mr={3}
          >
            Cancelar
          </Button>
          <Button colorScheme="blue" isLoading={loading} type="submit">
            Confirmar
          </Button>
        </ModalFooter>
      </Form>
    </ModalComponent>
  );
}
